import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/css/global.css';
import './assets/css/groupDP.css';
import request from "@/utils/request";
import fastClick from "fastclick";
fastClick.attach(document.body);

Vue.prototype.$echarts = window.echarts
Vue.use(ElementUI, { size: 'small' });
Vue.config.productionTip = false
Vue.prototype.request = request
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
